import React, { useEffect, useState } from 'react';
import { useGetList } from 'react-admin';
import { Line } from 'react-chartjs-2';
import { colorScheme } from '@ugo/data';
import { Box, Card, Typography } from '@material-ui/core';
import { endOfDay, format, isBefore, subWeeks } from 'date-fns';
import { getDaysArray } from '@ugo/utils';
import { ChartComponentProps } from '@ugo/models';

/**
 * Returns distinct count of drivers that were active on a day or at least 4 weeks before
 */
const groupDistinctActiveDriversByDay = (
  services: any,
  startDate: Date | null,
  endDate: Date | null
) => {
  const rangeActiveDriversByDays: number[] = [];
  let days: Date[] = [];

  if (!startDate || !endDate) {
    return { days, rangeActiveDriversByDays };
  }

  const reservationsArray = Object.keys(services).map((sid) => services[sid]);

  days = getDaysArray(startDate, endDate, true);

  days.forEach(() => rangeActiveDriversByDays.push(0));

  days.forEach((d, i) => {
    const reservationsInRangeForDayArray = reservationsArray.filter(
      (r) => !!r.driver_id && isBefore(new Date(r.accepted_at), endOfDay(d))
    );
    const distinctDrivers = [
      // @ts-ignore
      ...new Set(reservationsInRangeForDayArray.map((r) => r.driver_id)),
    ];
    rangeActiveDriversByDays[i] = distinctDrivers.length;
  });

  return { days, rangeActiveDriversByDays };
};

const NumberOfActiveDriversLineChart = (props: ChartComponentProps) => {
  const [graphData, setGraphData] = useState<number[]>([]);
  const [days, setDays] = useState<string[]>([]);

  const { data } = useGetList(
    'reservation',
    { page: 1, perPage: 999999 },
    { field: 'accepted_at', order: 'ASC' },
    {
      'accepted_at@_gte': subWeeks(props.startDate as Date, 4),
      'accepted_at@_lte': props.endDate,
    }
  );

  useEffect(() => {
    const { days, rangeActiveDriversByDays } = groupDistinctActiveDriversByDay(
      data,
      props.startDate,
      props.endDate
    );
    setDays(days.map((d) => format(d, 'yyyy-MM-dd')));
    setGraphData(rangeActiveDriversByDays);
  }, [data]);

  return (
    <Card>
      <Box px={2} pt={2}>
        <Typography color="textSecondary">
          <small>
            Accepted reservation on the day or at least 4 weeks prior
          </small>
        </Typography>
      </Box>
      <Box height="350px" px={2} pb={2}>
        <Line
          data={{
            labels: days,
            datasets: [
              {
                label: 'Active drivers',
                data: graphData,
                lineTension: 0,
                pointRadius: 2,
                borderColor: colorScheme[0],
                backgroundColor: 'transparent',
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              yAxes: [
                {
                  ticks: {
                    precision: 0,
                    beginAtZero: true,
                    min: 0,
                  },
                },
              ],
            },
          }}
        />
      </Box>
    </Card>
  );
};
export default NumberOfActiveDriversLineChart;
